import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'signin-reset_password-success';

/**
 * Tracks successful reset password calls
 */
export function trackSigninResetPasswordSuccess(
  sign_in_step_string: string,
  Reset_Method_string2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { sign_in_step_string, Reset_Method_string2 },
  });
}
